<template>
  <main class="main page-inside text-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title">{{textPageTitle}}</div>
        </div>
      </div>
      <div class="section text-section">
        <transition name="fade">
          <div class="wrapper" v-if="textPageTitle">
            <div class="desc" v-html="textPageHeader"></div>
            <div class="desc" v-html="textPageContent"></div>
          </div>
        </transition>
      </div>
    </div>
  </main>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TextPage',
  props: [],
  inject: ['textPageContent', 'textPageTitle', 'textPageHeader', 'getTextPageContent'],
  components: {
  },

  data: function() {
    return {
      
    }
  },

  mounted() {
    this.getTextPageContent(this.$route.params.id);
  },

  methods: {
    
  },
});
</script>